import * as React from 'react'
import { ResortTabs } from '@components/resort-tabs'
import { PageTitle } from '@hyper/page-title'
import { useDocumentTitle } from '@helpers/utils'
import { NavigationPath } from '@models/routes'
import { useParams } from 'react-router-dom'
import { Card, CardBody } from 'reactstrap'
import { useMenuActive } from '@components/hooks/use-menu-active'
import { useAuthenticatedUser } from '@components/hooks/use-authenticated-user'
import { ReceptionTechnicalOrderCreateButton } from '@modules/reception-technical-orders/reception-technical-order-create-button'
import { TableFilters } from '@components/table/table'
import { useGetReceptionTechnicalOrdersQuery } from '@api/technical-orders'
import { TypedQueryResult } from '@api/base'
import { TechnicalOrder } from '@models/technical-orders'
import { ReceptionTechnicalOrdersTable } from '@modules/reception-technical-orders/table'
import { TechnicalOrdersDetailsView } from '@modules/technical-orders/details'
import { ReceptionTechnicalOrdersFilters } from '@modules/reception-technical-orders/filters'

interface Params {
  resort_id: string
  id?: string
}
const defaultFilters: TableFilters = {
  search: '',
  ordering: 'resort',
  page: 1,
  page_size: 9999,
}
const emptyTable = []
export const ReceptionTechnicalOrdersView: React.FC = () => {
  const [filters, setFilters] = React.useState<TableFilters>(defaultFilters)

  const { resort_id, id = '' } = useParams() as unknown as Params
  const resortId = parseInt(resort_id, 10)
  const pageTitle = 'Usterki'

  const { data = emptyTable } = useGetReceptionTechnicalOrdersQuery({
    resort: resortId,
    ...filters,
  }) as TypedQueryResult<TechnicalOrder[]>

  const technicalOrders = React.useMemo(() => data.filter(row => !row.forwarded_to_technical_order), [data])
  const technicalOrdersForwarded = React.useMemo(() => data.filter(row => row.forwarded_to_technical_order), [data])

  useDocumentTitle(pageTitle)
  useMenuActive(NavigationPath.ReceptionTechnicalOrders)

  const user = useAuthenticatedUser()

  return (
    <>
      <TechnicalOrdersDetailsView id={id} kind="reception_technical_order" />
      <PageTitle breadCrumbItems={[{ label: pageTitle, path: '', active: true }]} title={pageTitle} />
      <Card>
        <CardBody>
          <ResortTabs
            showAll={user.isTechnicalOrderManager}
            resortId={resortId}
            url={NavigationPath.ReceptionTechnicalOrdersWithParams}
          >
            <ReceptionTechnicalOrderCreateButton resortId={resortId} />
          </ResortTabs>
          <ReceptionTechnicalOrdersFilters setFilters={setFilters} filters={filters} defaultFilters={defaultFilters} />

          <h4 className="text-danger">Nowe usterki:</h4>
          <ReceptionTechnicalOrdersTable
            dataTestId="qa-table-reception-technical-orders-new"
            setFilters={setFilters}
            filters={filters}
            technicalOrders={technicalOrders}
            showUsers={false}
          />
          <h4>Przekazane do realizacji:</h4>
          <ReceptionTechnicalOrdersTable
            setFilters={setFilters}
            filters={filters}
            dataTestId="qa-table-reception-technical-orders"
            technicalOrders={technicalOrdersForwarded}
            showUsers={true}
          />
        </CardBody>
      </Card>
    </>
  )
}
